import { render, staticRenderFns } from "./AdvertData.vue?vue&type=template&id=f9ce9cae&"
import script from "./AdvertData.vue?vue&type=script&lang=js&"
export * from "./AdvertData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports